module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('hospital-select', {
    on: {
      "selected": _vm.selectHospital
    }
  }), _vm._v(" "), _c('voucher-select', {
    attrs: {
      "list": _vm.voucherList
    },
    on: {
      "selected": _vm.selectVoucher
    }
  }), _vm._v(" "), _vm._l((_vm.inpatientList), function(item, index) {
    return _c('div', {
      staticClass: "dept-list"
    }, [_c('div', {
      staticClass: "dept-name"
    }, [_c('span', [_vm._v(_vm._s(item.deptName))]), _vm._v(" "), _c('span', {
      class: {
        blue: item.signState == '已预约',
          gray: item.signState == '已取消',
          green: item.signState == '已入院',
      }
    }, [_vm._v(_vm._s(item.signState))])]), _vm._v(" "), _c('div', {
      staticClass: "dept-doctor",
      on: {
        "click": function($event) {
          return _vm.goDetails(index)
        }
      }
    }, [_c('div', [_vm._v("开入院证时间:" + _vm._s(item.inTime))])])])
  }), _vm._v(" "), _c('no-record', {
    attrs: {
      "id": "myregister-norecord",
      "condition": _vm.inpatientList,
      "tips": "抱歉，没有住院记录"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e742129e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/inpatientRegister/InpatientRegister.vue
// module id = 882
// module chunks = 0